import resources from './index'

const userData = [
    {
        id: 1,
        image: resources.images.users.user1,
        name: "Joe Richard",
        title: "Visual Designer",
        job_title: "The Best Template You Got to Have it!",
        ratting: 5,
        job_desc: "Globally network long-term high-impact schemas vis-a-vis distinctive e-commerce cross-media infrastructures rather than ethical sticky alignments rather than global. Plagiarize technically sound total linkage for leveraged value media web-readiness and premium processes.",
    },
    {
        id: 2,
        image: resources.images.users.user2,
        name: "Rupan Oberoi",
        title: "Web Designer",
        job_title: "Embarrassed by the First Version.",
        ratting: 5,
        job_desc: "Energistically streamline robust architectures whereas distributed mindshare. Intrinsicly leverage other's backend growth strategies through 24/365 products. Conveniently pursue revolutionary communities for compelling process improvements.",
    },
    {
        id: 3,
        image: resources.images.users.user3,
        name: "Jon Deo",
        title: "Amazing Quiety template!",
        job_title: "The Best Template You Got to Have it!",
        ratting: 5,
        job_desc: "Appropriately negotiate interactive niches rather orchestrate scalable benefits whereas flexible systems. Objectively grow quality outsourcing without vertical methods of empowerment. Assertively negotiate just in time innovation after client-centered thinking.",
    },
    {
        id: 4,
        image: resources.images.users.user4,
        name: "Hanry Luice",
        title: "App Developer",
        job_title: "Best Template for SAAS Company!",
        ratting: 5,
        job_desc: "Competently repurpose cost effective strategic theme areas and customer directed meta-services. Objectively orchestrate orthogonal initiatives after enterprise-wide bandwidth. Dynamically generate extensive through cooperative channels time partnerships.",
    },
    {
        id: 5,
        image: resources.images.users.user5,
        name: "Ami Nijai",
        title: "Custoer Support",
        job_title: "The Best Template You Got to Have it!",
        ratting: 5,
        job_desc: "Appropriately disintermediate one-to-one vortals through cross functional infomediaries. Collaboratively pursue multidisciplinary systems through stand-alone architectures. Progressively transition covalent architectures whereas vertical applications procrastinate professional.",
    },
]

export default userData ;